import { Card, theme, Typography } from "kosmos-ui/lib";

import { useLayout } from "app/context/LayoutContext/hooks";
import { CheckIcon } from "app/assets/icons";

import { PLANS } from "./constants";
import {
  PlansContainer,
  PlansFeatureContainer,
  PlansCardsContainer,
  PlansIconContainer,
} from "./styles";

export default function PlansSection() {
  const { mobile } = useLayout();

  return (
    <PlansContainer>
      <Typography
        as="h1"
        variant="title1"
        style={{
          color: theme.colorsPalette.white.default,
          maxWidth: 620,
          textAlign: "center",
        }}
      >
        Planes.
      </Typography>

      <Typography
        variant="paragraph1"
        style={{ maxWidth: 620, textAlign: "center", marginBottom: 0 }}
      >
        Pensandos en las distintas etapas de tu proyecto.
      </Typography>

      <Typography
        variant="paragraph1"
        style={{ maxWidth: 620, textAlign: "center" }}
      >
        Modelo de cobro elástico, donde si tú ganas, nosotros ganamos.
      </Typography>

      <PlansCardsContainer>
        {PLANS.map((plan, index) => {
          return (
            <Card
              style={{
                padding: mobile ? "32px 24px" : "32px 54px",
                alignItems: mobile ? "center" : "unset",
                backgroundColor: theme.colorsPalette.black.default,
              }}
              key={index}
            >
              <PlansIconContainer>{plan.icon}</PlansIconContainer>

              <Typography
                as="h1"
                variant="title3"
                style={{
                  color: theme.colorsPalette.white.default,
                  marginBottom: 8,
                }}
              >
                {plan.name}
              </Typography>

              <Typography
                as="b"
                variant="paragraph1"
                style={{
                  color: theme.colorsPalette.blue.default,
                }}
              >
                {plan.price}
              </Typography>

              {plan.features.map((feature, index) => {
                return (
                  <PlansFeatureContainer key={index}>
                    <CheckIcon
                      height="18px"
                      style={{ marginRight: 8 }}
                      color={
                        feature.isNew
                          ? theme.colorsPalette.blue.default
                          : theme.colorsPalette.gray.dark
                      }
                    />

                    <Typography
                      as="p"
                      variant="paragraph3"
                      style={{
                        color: feature.isNew
                          ? theme.colorsPalette.gray.light
                          : theme.colorsPalette.gray.dark,
                      }}
                    >
                      {feature.name}
                    </Typography>
                  </PlansFeatureContainer>
                );
              })}
            </Card>
          );
        })}
      </PlansCardsContainer>

      <Typography
        as="p"
        variant="paragraph2"
        style={{ marginTop: 48, textAlign: mobile ? "center" : "unset" }}
      >
        Todos los planes siguientes al plan base, consideran 5% por venta.
      </Typography>
    </PlansContainer>
  );
}
